export enum ColumnFilterType {
	TEXT = 'TEXT',
	LIST = 'LIST',
	FLAG = 'FLAG',
	DATE = 'DATE'
}